module.exports = __webpack_public_path__ + "img/pinterest.a850427b.svg";